import baseAxiosAuth from './config/baseAxiosAuth';

async function getPerfil() {
    return baseAxiosAuth.get('/api/meu-perfil');
}

async function putPerfil(payload) {
    return baseAxiosAuth.put('/api/meu-perfil', payload);
}

async function putPerfilVendedorPadrao(codigo) {
    return baseAxiosAuth.put(`/api/meu-perfil/vendedor-padrao/${codigo}`);
}

export {
    getPerfil,
    putPerfil,
    putPerfilVendedorPadrao
};